import React from 'react';
import ReactDOM from 'react-dom';
import {HashRouter as Router} from 'react-router-dom';
import "react-quill-emoji/dist/quill-emoji.css";
import "react-quill/dist/quill.snow.css";
import 'react-perfect-scrollbar/dist/css/styles.css';
import './less/index.less';
import moment from 'moment';
import 'moment-timezone';
import App from './App';
import startCheckingForNewBuild from 'utils/refreshUtil';
import { Spin } from 'antd';
import { Spin as SpinV5 } from 'antd-v5';
import { LoadingIcon } from './components/Icons';
import ConfigurationProvider from './components/ConfigurationProvider';
import 'rc-trigger/assets/index.css';
import ACLoadingIcon from './ac-components/ac-icons/LoadingIcon';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import duration from "dayjs/plugin/duration";
import { initSentry } from './sentry';
import customParseFormat from "dayjs/plugin/customParseFormat";
import advancedFormat from "dayjs/plugin/advancedFormat";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(customParseFormat);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);


moment.updateLocale('en', {
  relativeTime : {
    m:  "1 minute",
    h:  "1 hour",
    M:  "1 month",
    y:  "1 year",
  }
});

Spin.setDefaultIndicator(<LoadingIcon />);
SpinV5.setDefaultIndicator(<ACLoadingIcon className="font-size-24" />);

initSentry();

ReactDOM.render(
  // <React.StrictMode>
    <Router>
      <ConfigurationProvider>
        <App />
      </ConfigurationProvider>
    </Router>,
  // </React.StrictMode>,
  document.getElementById('root')
);


startCheckingForNewBuild();
